import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import lcgLogo from '../LCG-Logo.png';
import { ContactForm } from './ContactForm';

const NavBar: React.FC = () => {
  const [isContactFormOpen, setIsContactFormOpen] = useState(false);

  const handleOpenContactForm = () => {
    setIsContactFormOpen(true);
  };

  const handleCloseContactForm = () => {
    setIsContactFormOpen(false);
  };

  return (
    <>
      <nav className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <img src={lcgLogo} alt="LCG Logo" className="h-10 w-auto mr-3" />
            </div>
            <div className="hidden md:flex items-center space-x-4">
              <Link to="/" className="text-gray-700 hover:text-primary">Home</Link>
              <Link to="/about" className="text-gray-700 hover:text-primary">About</Link>
              <button
                onClick={handleOpenContactForm}
                className="bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
      </nav>

      <ContactForm isOpen={isContactFormOpen} onClose={handleCloseContactForm} />
    </>
  );
};

export default NavBar;
